import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function SeatsIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M16.0001 5.8541C16.0001 4.71779 15.3706 3.63236 14.2779 3.32044C13.5667 3.11741 12.8128 3 12.0001 3C11.1874 3 10.4334 3.11741 9.72222 3.32044C8.62955 3.63236 8.00004 4.71779 8.00004 5.8541L8.00004 13C8.00004 13.5523 8.44776 14 9.00005 14L15.0001 14C15.5524 14 16.0001 13.5523 16.0001 13L16.0001 5.8541Z" fill="#62666B" />
            <path d="M3 13C3 12.4477 3.44772 12 4.00001 12H5.00002C5.5523 12 6.00002 12.4477 6.00002 13C6.00002 13.5523 5.5523 14 5.00002 14H4.00001C3.44772 14 3 13.5523 3 13Z" fill="#62666B" />
            <path d="M5.00002 17C5.00002 16.4477 5.44773 16 6.00002 16L18.0001 16C18.5524 16 19.0001 16.4477 19.0001 17L19.0001 20C19.0001 20.5523 18.5524 21 18.0001 21C17.4478 21 17.0001 20.5523 17.0001 20V19L7.00003 19V20C7.00003 20.5523 6.55231 21 6.00002 21C5.44773 21 5.00002 20.5523 5.00002 20L5.00002 17Z" fill="#62666B" />
            <path d="M19.0001 12C18.4478 12 18.0001 12.4477 18.0001 13C18.0001 13.5523 18.4478 14 19.0001 14H20.0001C20.5524 14 21.0001 13.5523 21.0001 13C21.0001 12.4477 20.5524 12 20.0001 12H19.0001Z" fill="#62666B" />
        </SvgIcon>
    );
}

export default SeatsIcon;
